<div id="time-table" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Time Table & Lesson Plans</h2>
    <p class="inner-lead mt-3">
      Shah Satnam Ji Girls' College, Sirsa outlines structured schedules and systematic teaching strategies to guide our students through their academic journey. Explore both schedules and lesson plans below.
    </p>

    <hr class="divider">

    <!-- ==============================================
         SECTION 1: CLASS TIME TABLE
         ============================================== -->
    <div class="mt-4">
      <h3 class="section-title-navy"><i class="fa fa-clock-o me-2"></i> Class Time Table</h3>
      <p class="inner-lead mb-3">View class-wise timetables and weekly routines for different academic sessions.</p>
      
      <!-- Time Table Year Tabs -->
      <div class="report-tabs-wrapper mt-3">
        <div class="report-tabs">
          <button class="tab-btn" [class.active]="activeTimetableTab === '2024-25'" (click)="setActiveTimetableTab('2024-25')">
            <i class="fa fa-calendar me-2"></i> 2024-25
          </button>
          <button class="tab-btn" [class.active]="activeTimetableTab === '2023-24'" (click)="setActiveTimetableTab('2023-24')">
            <i class="fa fa-calendar me-2"></i> 2023-24
          </button>
          <button class="tab-btn" [class.active]="activeTimetableTab === '2022-23'" (click)="setActiveTimetableTab('2022-23')">
            <i class="fa fa-calendar me-2"></i> 2022-23
          </button>
          <button class="tab-btn" [class.active]="activeTimetableTab === '2021-22'" (click)="setActiveTimetableTab('2021-22')">
            <i class="fa fa-calendar me-2"></i> 2021-22
          </button>
        </div>
      </div>

      <!-- Time Table Content Area -->
      <div class="tab-content-area mt-4">
        <!-- 2024-25 Tab -->
        <div *ngIf="activeTimetableTab === '2024-25'" class="animate-fade-in">
          <h4 class="section-subtitle">Class Time Table — Session 2024-2025</h4>
          <div class="pdf-block">
            <pdf-viewer src="/assets/pdf/academics/Time-table-uploaded-on-website.pdf" [render-text]="true"
              [original-size]="false" style="width:100%; height:680px; display:block;">
            </pdf-viewer>
          </div>
          <div class="mt-3">
            <a href="/assets/pdf/academics/Time-table-uploaded-on-website.pdf" target="_blank" class="pdf-download-btn">
              <i class="fa fa-download"></i> Download Time Table 2024-25
            </a>
          </div>
        </div>

        <!-- 2023-24 Tab -->
        <div *ngIf="activeTimetableTab === '2023-24'" class="animate-fade-in">
          <h4 class="section-subtitle">Class Time Table — Session 2023-2024</h4>
          <div class="pdf-block">
            <pdf-viewer src="/assets/pdf/academics/Time-table-uploaded-on-website.pdf" [render-text]="true"
              [original-size]="false" style="width:100%; height:680px; display:block;">
            </pdf-viewer>
          </div>
          <div class="mt-3">
            <a href="/assets/pdf/academics/Time-table-uploaded-on-website.pdf" target="_blank" class="pdf-download-btn">
              <i class="fa fa-download"></i> Download Time Table 2023-24
            </a>
          </div>
        </div>

        <!-- 2022-23 Tab -->
        <div *ngIf="activeTimetableTab === '2022-23'" class="animate-fade-in">
          <h4 class="section-subtitle">Class Time Table — Session 2022-2023</h4>
          <div class="pdf-block">
            <pdf-viewer src="/assets/pdf/academics/Time-table-uploaded-on-website.pdf" [render-text]="true"
              [original-size]="false" style="width:100%; height:680px; display:block;">
            </pdf-viewer>
          </div>
          <div class="mt-3">
            <a href="/assets/pdf/academics/Time-table-uploaded-on-website.pdf" target="_blank" class="pdf-download-btn">
              <i class="fa fa-download"></i> Download Time Table 2022-23
            </a>
          </div>
        </div>

        <!-- 2021-22 Tab -->
        <div *ngIf="activeTimetableTab === '2021-22'" class="animate-fade-in">
          <h4 class="section-subtitle">Class Time Table — Session 2021-2022</h4>
          <div class="pdf-block">
            <pdf-viewer src="/assets/pdf/academics/Time-table-uploaded-on-website.pdf" [render-text]="true"
              [original-size]="false" style="width:100%; height:680px; display:block;">
            </pdf-viewer>
          </div>
          <div class="mt-3">
            <a href="/assets/pdf/academics/Time-table-uploaded-on-website.pdf" target="_blank" class="pdf-download-btn">
              <i class="fa fa-download"></i> Download Time Table 2021-22
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Section Divider -->
    <hr class="academics-divider">

    <!-- ==============================================
         SECTION 2: ACADEMIC LESSON PLANS
         ============================================== -->
    <div>
      <h3 class="section-title-navy"><i class="fa fa-book me-2"></i> Academic Lesson Plans</h3>
      <p class="inner-lead mb-3">Explore detailed teaching schedules, lesson units, and course planning models.</p>
      
      <!-- Lesson Plans Year Tabs -->
      <div class="report-tabs-wrapper mt-3">
        <div class="report-tabs">
          <button class="tab-btn" [class.active]="activeLessonPlanTab === '2024-25'" (click)="setActiveLessonPlanTab('2024-25')">
            <i class="fa fa-calendar me-2"></i> 2024-25
          </button>
          <button class="tab-btn" [class.active]="activeLessonPlanTab === '2023-24'" (click)="setActiveLessonPlanTab('2023-24')">
            <i class="fa fa-calendar me-2"></i> 2023-24
          </button>
          <button class="tab-btn" [class.active]="activeLessonPlanTab === '2022-23'" (click)="setActiveLessonPlanTab('2022-23')">
            <i class="fa fa-calendar me-2"></i> 2022-23
          </button>
          <button class="tab-btn" [class.active]="activeLessonPlanTab === '2021-22'" (click)="setActiveLessonPlanTab('2021-22')">
            <i class="fa fa-calendar me-2"></i> 2021-22
          </button>
        </div>
      </div>

      <!-- Lesson Plans Content Area -->
      <div class="tab-content-area mt-4">
        <!-- 2024-25 Tab (Shows 23-24 plan as active sample) -->
        <div *ngIf="activeLessonPlanTab === '2024-25'" class="animate-fade-in">
          <h4 class="section-subtitle">Academic Lesson Plan — Session 2024-2025</h4>
          <div class="pdf-block">
            <pdf-viewer src="/assets/pdf/academics/Lesson-Plan-Sample-2023-24.pdf" [render-text]="true"
              [original-size]="false" style="width:100%; height:680px; display:block;">
            </pdf-viewer>
          </div>
          <div class="mt-3">
            <a href="/assets/pdf/academics/Lesson-Plan-Sample-2023-24.pdf" target="_blank" class="pdf-download-btn">
              <i class="fa fa-download"></i> Download Lesson Plan 2024-25
            </a>
          </div>
        </div>

        <!-- 2023-24 Tab -->
        <div *ngIf="activeLessonPlanTab === '2023-24'" class="animate-fade-in">
          <h4 class="section-subtitle">Academic Lesson Plan — Session 2023-2024</h4>
          <div class="pdf-block">
            <pdf-viewer src="/assets/pdf/academics/Lesson-Plan-Sample-2023-24.pdf" [render-text]="true"
              [original-size]="false" style="width:100%; height:680px; display:block;">
            </pdf-viewer>
          </div>
          <div class="mt-3">
            <a href="/assets/pdf/academics/Lesson-Plan-Sample-2023-24.pdf" target="_blank" class="pdf-download-btn">
              <i class="fa fa-download"></i> Download Lesson Plan 2023-24
            </a>
          </div>
        </div>

        <!-- 2022-23 Tab -->
        <div *ngIf="activeLessonPlanTab === '2022-23'" class="animate-fade-in">
          <h4 class="section-subtitle">Academic Lesson Plan — Session 2022-2023</h4>
          <div class="pdf-block">
            <pdf-viewer src="/assets/pdf/academics/Lesson-Plan-Sample-2022-23.pdf" [render-text]="true"
              [original-size]="false" style="width:100%; height:680px; display:block;">
            </pdf-viewer>
          </div>
          <div class="mt-3">
            <a href="/assets/pdf/academics/Lesson-Plan-Sample-2022-23.pdf" target="_blank" class="pdf-download-btn">
              <i class="fa fa-download"></i> Download Lesson Plan 2022-23
            </a>
          </div>
        </div>

        <!-- 2021-22 Tab -->
        <div *ngIf="activeLessonPlanTab === '2021-22'" class="animate-fade-in">
          <h4 class="section-subtitle">Academic Lesson Plan — Session 2021-2022</h4>
          <div class="pdf-block">
            <pdf-viewer src="/assets/pdf/academics/Lesson-Plan-Sample-2021-22.pdf" [render-text]="true"
              [original-size]="false" style="width:100%; height:680px; display:block;">
            </pdf-viewer>
          </div>
          <div class="mt-3">
            <a href="/assets/pdf/academics/Lesson-Plan-Sample-2021-22.pdf" target="_blank" class="pdf-download-btn">
              <i class="fa fa-download"></i> Download Lesson Plan 2021-22
            </a>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>